import CardSystem from '../CardSystem';
import BaseCardHandler from './BaseCardHandler';
import { ICardsState } from 'State/Card/ICardState';

export default class PlusThreeCardHandler extends BaseCardHandler {
    // Empty override to prevent the card from being hidden on discard
    public handleCardDiscarded(state: ICardsState, cardSystem: CardSystem): void {}
}
